import { render, staticRenderFns } from "./DonorMedicalDetailsPrint.vue?vue&type=template&id=84e5f936"
import script from "./DonorMedicalDetailsPrint.vue?vue&type=script&lang=js"
export * from "./DonorMedicalDetailsPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports